<template>
    <v-container fluid>
        <v-row wrap>
            <v-col cols="12" md="6">
                <v-btn class="ma-2" v-if="!addingNewComment" text @click="openCommentEditor()">
                    New Comment
                    <v-icon right dark>mdi-plus</v-icon>
                </v-btn>
            </v-col>
            <v-col cols="12" md="6">
                <v-select v-if="!addingNewComment"
                    v-model="filterOptions.sortBy"
                    :items="sortOptions"   
                    label="Sort By"
                    flat
                    @change="updateFilterOptions()"
                ></v-select>
            </v-col>
        </v-row>
        <v-slide-y-reverse-transition>
            <v-card flat v-if="addingNewComment">
                <v-textarea
                    class="pl-3 pr-3"
                    v-model="newComment.commentText"
                    label="Enter Comment Here"
                    :counter="commentRules.max"
                ></v-textarea>
                <v-card-actions>
                    <v-btn
                    text
                    color="primary"
                    @click="postNewComment()"
                    >
                    Post Comment
                    </v-btn>
                    <v-btn
                    text
                    color="secondary"
                    @click="closeCommentEditor()"
                    >
                    Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-slide-y-reverse-transition>
        <div v-if="hasComments">
            <v-card
            tile
            dense
            v-for="comment in localCommentsList"
            :key="comment.id">
                <comment :comment="comment" :parentId="parentId" v-on:viewUserProfile="viewUserProfile($event)" :parentType="parentType"></comment>
            </v-card>
        </div>
        <div v-else>
            <v-card-title>There are no comments to be shown</v-card-title>
        </div>

        <v-dialog v-model="viewProfileDialog" :retain-focus="false" fullscreen hide-overlay transition="dialog-bottom-transition">              
            <profile-screen
            v-if="viewProfileDialog"
            v-on:dialogClosed="closeViewProfile()"
            :user="currentViewedUser"
            :label="currentViewedUser.displayname"
            :myProfile="false">
            </profile-screen>
        </v-dialog>
    </v-container>
</template>

<script>
import firebase from '@/fb'; 
import fbAdmin from 'firebase';
import Comment from './Comment.vue';
import moment from 'moment';
import UserDataService from './../../../services/userDataService.js';
import Activity from './../../Management/ActivityTracker/activity.js';
import ProfileScreen from './../../Management/ProfileScreen.vue';
import Toast from './../../../plugins/customToast.js';

export default {
    data () {
      return {
        localCommentsList: [],
        addingNewComment: false,
        newComment: {
            owner: "",
            upvotes: 0,
            votedBy: [],
            date: null,
            ownerName: "",
            commentText: ""
        },
        commentRules: {
            max: 250
        },
        sortOptions: ['Newest', 'Most Popular'],
        filterOptions: {
            sortBy: "Newest"
        },
        userDataService: new UserDataService(),
        viewProfileDialog: false,
        currentViewedUser: {}
      }
    },
    props: {
        comments: Array,
        parentId: String,
        parentType: String
    },
    components: {
        Comment,
        ProfileScreen
    },
    watch: {
        comments: {
            // the callback will be called immediately after the start of the observation
            immediate: true, 
            handler (val) {
                if (this.localCommentsList !== val){
                    this.localCommentsList = val;
                }
            }
        }
    },
    computed: {
        hasComments(){
            if (this.localCommentsList){
                return this.localCommentsList.length > 0;
            } else {
                return false;
            }
        }
    },
    beforeCreate() {
        this.$options.components.ProfileScreen = require('./../../Management/ProfileScreen.vue').default
    },
    mounted(){
        //Sort our initial comments list into the order that corresponds with the default filterOptions
        this.updateFilterOptions();
    },
    methods: {
        openCommentEditor(){
            this.addingNewComment = true;
            this.newComment = {
                owner: "",
                upvotes: 0,
                votedBy: [],
                date: null,
                ownerName: "",
                commentText: ""
            }
        },
        closeCommentEditor(){
            this.addingNewComment = false;
            this.newComment = {
                owner: "",
                upvotes: 0,
                votedBy: [],
                date: null,
                ownerName: "",
                commentText: ""
            }
        },
        postNewComment(){
            var that = this;
            //Validate the comments length first
            var valid = this.validateComment(this.newComment);

            //Add everything else to the comment
            this.newComment.owner = this.$route.params.userDb.uid;
            this.newComment.ownerName = this.$route.params.userDb.displayname;
            this.newComment.date = moment(new Date()).format('MM-DD-YYYY hh:mm A');

            if (valid) {
                //Setup the update object
                const updateObject = this.newComment;
                var collectionReference;
                if (this.parentType == "case"){
                    collectionReference = firebase.db.collection('cases');
                } else {
                    collectionReference = firebase.db.collection('treatments');
                }
                //Do firebase update
                collectionReference
                .doc(this.parentId)
                .update({comments: fbAdmin.firestore.FieldValue.arrayUnion(updateObject)})
                .then(function(){
                    //Push the activity to the tracker
                    that.activity = new Activity("Posted", {type: "Comment", id: that.parentId}, moment(new Date()).format('MM-DD-YYYY hh:mm A'));
                    that.activity.pushActivityToFirebase(that.$route.params.userDb.uid);

                    //Give the user feedback on what they posted
                    Toast.fire({  icon: 'success',  title: `Comment successfully posted!`});
                    //Emit something to refresh the comments page
                    that.closeCommentEditor();
                    that.$emit("updateComments");
                })
                .catch(function(error){
                    //Alert them of the failed comment post
                    Toast.fire({  icon: 'error',  title: `Error posting the comment: ${error}`});
                })
            }
        },
        validateComment(comment){
            if (comment.commentText.length > 250) {
                return false;
            } else {
                return true;
            }
        },
        updateFilterOptions(){
            ///////////
            ///SORT////
            ///////////
            var filteredCommentsList = this.localCommentsList;

            //If sortBy isnt null change the sort
            if (this.filterOptions.sortBy !== null && this.filterOptions.sortBy !== "Not Selected"){
                //Sort Filter
                //Determine which sort is to be used:
                switch (this.filterOptions.sortBy) {
                    case "Newest":
                        //Sort based on the date (will have to do a moments conversion?) --> Need to take into account time as well
                        filteredCommentsList = filteredCommentsList.sort(function (a, b){
                            if (moment(a.date).isAfter(moment(b.date))){
                                return -1;
                            } else if (moment(a.date).isBefore(moment(b.date))){
                                return 1;
                            } else {
                                return 0;
                            }
                        });
                        break;
                    case "Most Popular":
                        //Sort based on upvotes, greatest at the top
                        filteredCommentsList = filteredCommentsList.sort(function (a, b){
                            return b.upvotes - a.upvotes;
                        });
                        break;
                    }
            }
            this.localCommentsList = filteredCommentsList;
        },
        async viewUserProfile(profileId){
            var that = this;
            this.userDataService.searchFirebaseByUserId(profileId)
            .then(function (result) {
                if (result !== null){
                    //If call was successful for user, show their profile page
                    console.log("viewing user profile: " + result); //eslint-disable-line
                    that.currentViewedUser = result;
                    that.viewProfileDialog = true;
                } else {
                    Toast.fire({  icon: 'error',  title: `Cannot currently view user profile`});
                }            
            }).catch(function (error) {
                Toast.fire({  icon: 'error',  title: `Cannot currently view user profile: ${error}`});
            });        
        },
        closeViewProfile(){
            this.currentViewedUser = {};
            this.viewProfileDialog = false;
        },
    }
  }
</script>